import { render, staticRenderFns } from "./shoppingDestination.vue?vue&type=template&id=4c96280e"
import script from "./shoppingDestination.vue?vue&type=script&lang=js"
export * from "./shoppingDestination.vue?vue&type=script&lang=js"
import style0 from "./shoppingDestination.vue?vue&type=style&index=0&id=4c96280e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports